<template>
    <div>
               
    <div class="trashed_doc_wrapper">
        
        <ul>
            <template v-if="value && checkProperty(value,'length')>0" v-for="(mItem,mIndex) in value">
                <template>
                    <template v-if="checkProperty(mItem,'path') && checkProperty(mItem,'isTrashDocument')">
                        <li >
                            {{ mItem['name'] }}
                            <span v-if="checkProperty(mItem,'path')" class="doc_delete doc_view" >
                                <img src="@/assets/images/main/eye.png"  @click="downloadView(mItem)" />
                                <em>View/Download</em>
                            </span>
                            <span class="doc_delete">
                                <img src="@/assets/images/main/delete-row-img.svg" @click="moveToTrash(mItem,false )" />
                                <em>Remove from the Trash</em>
                            </span>
                        </li>
                    </template>
                    <template v-else>
                        <template v-if="checkProperty(mItem,'tasks') && checkProperty(mItem,'tasks','length')>0"
                            v-for="(sItem,sIndex) in mItem['tasks']">
                            <template >
                                <template v-if="checkProperty(sItem,'path') && checkProperty(sItem,'isTrashDocument')">
                                    <li>
                                        {{ sItem['name'] }}
                                        <span class="doc_delete doc_view">
                                            <img src="@/assets/images/main/eye.png"  @click="downloadView(sItem)"/>
                                            <em>View/Download</em>
                                        </span>
                                        <span class="doc_delete">
                                            <img src="@/assets/images/main/delete-row-img.svg" @click="moveToTrash(sItem,false )" />
                                            <em>Remove from the Trash</em>
                                        </span>
                                    </li>
                                </template>
                                <template v-else>
                                    <template v-if="checkProperty(sItem,'tasks') && checkProperty(sItem,'tasks','length')>0"
                                        v-for="(item,index) in sItem['tasks']">
                                        <template >
                                            <template v-if="checkProperty(item,'path') && checkProperty(item,'isTrashDocument')">
                                                <li>
                                                  
                                                    {{ item['name'] }}
                                                    <span class="doc_delete doc_view">
                                                        <img src="@/assets/images/main/eye.png"  @click="downloadView(item)"/>
                                                        <em>View/Download</em>
                                                    </span>
                                                    <span class="doc_delete">
                                                        <img src="@/assets/images/main/delete-row-img.svg" @click="moveToTrash(item,false )" />
                                                        <em>Remove from the Trash</em>
                                                    </span>
                                                    
                                                </li>
                                            </template>
                                            <template v-else>
                                                <template v-if="checkProperty(item,'tasks') && checkProperty(item,'tasks','length')>0"
                                                    v-for="(CItem,cindex) in item['tasks']">
                                                    <template >
                                                        <template v-if="checkProperty(CItem,'path') && checkProperty(CItem,'isTrashDocument')">
                                                            <li>
                                                                {{ CItem['name'] }}
                                                                <span class="doc_delete doc_view">
                                                                    <img src="@/assets/images/main/eye.png"  @click="downloadView(CItem)"/>
                                                                    <em>View/Download</em>
                                                                </span>
                                                                <span class="doc_delete">
                                                                    <img src="@/assets/images/main/delete-row-img.svg" @click="moveToTrash(CItem,false )" />
                                                                    <em>Remove from the Trash</em>
                                                                </span>
                                                                
                                                            </li>
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="checkProperty(CItem,'tasks') && checkProperty(CItem,'tasks','length')>0"
                                                                v-for="(dItem,dindex) in CItem['tasks']">
                                                                <template >
                                                                    <template v-if="checkProperty(dItem,'path') && checkProperty(dItem,'isTrashDocument')">
                                                                        <li>
                                                                            {{ dItem['name'] }}
                                                                            <span class="doc_delete doc_view">
                                                                                <img src="@/assets/images/main/eye.png" @click="downloadView(dItem)"/>
                                                                                <em>View/Download</em>
                                                                            </span>
                                                                            <span class="doc_delete">
                                                                                <img src="@/assets/images/main/delete-row-img.svg" @click="moveToTrash(dItem,false )" />
                                                                                <em>Remove from the Trash</em>
                                                                            </span>
                                                                            
                                                                        </li>
                                                                    </template>
                                                                    <template v-else>
                                                                        <template v-if="checkProperty(dItem,'tasks') && checkProperty(dItem,'tasks','length')>0"
                                                                            v-for="(dbItem,dbindex) in dItem['tasks']">
                                                                            <template >
                                                                                <template v-if="checkProperty(dbItem,'path') && checkProperty(dbItem,'isTrashDocument')">
                                                                                    <li>
                                                                                        {{ dbItem['name'] }}
                                                                                        <span class="doc_delete doc_view">
                                                                                            <img src="@/assets/images/main/eye.png" @click="downloadView(dItem)"/>
                                                                                            <em>View/Download</em>
                                                                                        </span>
                                                                                        <span class="doc_delete">
                                                                                            <img src="@/assets/images/main/delete-row-img.svg" @click="moveToTrash(dbItem,false )" />
                                                                                            <em>Remove from the Trash</em>
                                                                                        </span>
                                                                                        
                                                                                    </li>
                                                                                </template>
                                                                            </template>
                                                                        </template>
                                                                    </template>
                                                                </template>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>
                                    </template>
                                </template>
                            </template>
                        </template>
                    </template>
                </template>
            </template>
            
        </ul>
        <template>
            <NoDataFound :loading="false" ref="NoDataFoundRef"  v-if="checkValue" content=""  heading="No Documents Found." type='documents' />
        </template>
        
    </div>
    </div>
  </template>
  <script>
  import NoDataFound from "@/views/common/noData.vue";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import draggable from "vuedraggable";
  
  import * as _ from "lodash";
  export default {
    mounted(){
      setTimeout(()=>{
       // this.init();
      },10000);
      setTimeout(()=>{
                        this.updateLoading(false)
                    },10);
    },
    data() {
      return {
        allTasks:[],
        finalSaveItems:[],
  
      }
    },
    methods:{
        downloadView(value){
            
           this.$emit('download_or_view' ,value);
        },
      downLoadAction(){
        this.finalSaveItems = [];
  
      },
      moveToTrash(selectedItem, action = false) {
      if (!_.has(selectedItem, "isTrashDocument")) {
        Object(selectedItem, { "isTrashDocument": action });
        selectedItem['isTrashDocument'] = action
      }
      selectedItem['isTrashDocument'] = action
      let _self = this;

      //isTrashDocument
        if (_.has(selectedItem, 'tasks') && selectedItem['tasks'] && this.checkProperty(selectedItem, 'tasks', 'length') > 0) {
      _.forEach(selectedItem['tasks'], (mTItem) => {
        mTItem['isTrashDocument'] = action
        if (_.has(mTItem, 'tasks') && mTItem['tasks'] && this.checkProperty(mTItem, 'tasks', 'length') > 0) {
          _.forEach(mTItem['tasks'], (sItem) => {
            sItem['isTrashDocument'] = action

            if (_.has(sItem, 'tasks') && sItem['tasks'] && this.checkProperty(sItem, 'tasks', 'length') > 0) {
              _.forEach(sItem['tasks'], (item) => {
                item['isTrashDocument'] = action
                if (_.has(item, 'tasks') && item['tasks'] && this.checkProperty(item, 'tasks', 'length') > 0) {
                  _.forEach(item['tasks'], (docItem) => {
                    docItem['isTrashDocument'] = action
                    if (_.has(docItem, 'tasks') && docItem['tasks'] && this.checkProperty(docItem, 'tasks', 'length') > 0) {
                      _.forEach(docItem['tasks'], (lItem) => {
                        lItem['isTrashDocument'] = action
                        if (_.has(lItem, 'tasks') && lItem['tasks'] && this.checkProperty(lItem, 'tasks', 'length') > 0) {
                          _.forEach(lItem['tasks'], (DItem) => {
                            DItem['isTrashDocument'] = action
                          })
                        }

                      })
                    }

                  })
                }

              })
            }


          })
        }




      })
        }
        let selectedPath =_self.checkProperty(selectedItem, 'path');
        if(_self.value && _self.checkProperty(_self.value,'length')>0 && selectedPath){
            _.forEach(_self.value,(mItem)=>{
                if(_.has(mItem,'path') && _self.checkProperty(mItem, 'path') == selectedPath ){
                    mItem['isTrashDocument'] = false;
                    return false
                }else if( _self.checkProperty(mItem, 'tasks') && _self.checkProperty(mItem, 'tasks' ,'length') >0){
                    _.forEach(mItem['tasks'],(sItem)=>{
                        if(_.has(sItem,'path') && _self.checkProperty(sItem, 'path') == selectedPath ){
                            mItem['isTrashDocument'] = false;
                            sItem['isTrashDocument'] = false;
                            return false;
                        }else if(_self.checkProperty(sItem, 'tasks') && _self.checkProperty(sItem, 'tasks' ,'length') >0){
                            _.forEach(sItem['tasks'],(item)=>{
                                if(_.has(item,'path') && _self.checkProperty(item, 'path') == selectedPath ){
                                    item['isTrashDocument'] = false;
                                    mItem['isTrashDocument'] = false;
                                    sItem['isTrashDocument'] = false;
                                    return false;
                                }else if(_self.checkProperty(item, 'tasks') && _self.checkProperty(item, 'tasks' ,'length') >0){
                                    _.forEach(item['tasks'],(dItem)=>{
                                        if(_.has(dItem,'path') && _self.checkProperty(dItem, 'path') == selectedPath ){
                                            dItem['isTrashDocument'] = false;
                                            item['isTrashDocument'] = false;
                                            mItem['isTrashDocument'] = false;
                                            sItem['isTrashDocument'] = false;
                                            return false;
                                        }else if(_self.checkProperty(dItem, 'tasks') && _self.checkProperty(dItem, 'tasks' ,'length') >0){
                                            _.forEach(dItem['tasks'],(dbItem)=>{
                                                if(_.has(dbItem,'path') && _self.checkProperty(dbItem, 'path') == selectedPath ){
                                                    dbItem['isTrashDocument'] = false;
                                                    dItem['isTrashDocument'] = false;
                                                    item['isTrashDocument'] = false;
                                                    mItem['isTrashDocument'] = false;
                                                    sItem['isTrashDocument'] = false;
                                                    return false;
                                                }else if(_self.checkProperty(dbItem, 'tasks') && _self.checkProperty(dbItem, 'tasks' ,'length') >0){
                                                    _.forEach(dbItem['tasks'],(yItem)=>{
                                                        if(_.has(yItem,'path') && _self.checkProperty(yItem, 'path') == selectedPath ){
                                                            yItem['isTrashDocument'] = false;
                                                            dbItem['isTrashDocument'] = false;
                                                            dItem['isTrashDocument'] = false;
                                                            item['isTrashDocument'] = false;
                                                            mItem['isTrashDocument'] = false;
                                                            sItem['isTrashDocument'] = false;
                                                            return false;
                                                        }
                                                    })
                                                }
                                            })
                                        }
                                    })
                                }
                            })
                        }
                    })
                }
            })
        }

    },
      remMveFromTrash(item){
        if(!_.has(item ,"isTrashDocument" )){
          Object(item ,{ "isTrashDocument":false});
          item['isTrashDocument'] =false
        }
        item['isTrashDocument'] =false;
        _.forEach(item['tasks'] ,(taskItem)=>{
          Object(taskItem ,{ "isTrashDocument":false});
             taskItem['isTrashDocument'] =false;
          });
        //isTrashDocument
      },
      
    },
    props:{
        value:null,
      groupName:{
       type:String,
       default:'g1'
      },
      isTrashDocument:{
  
       
        type: Boolean,
        default:false
      },
      petitionDetails:{
        type: Object,
        default: null,
      },
      tasks:{
      
        type: Array
      }
    },
    components:{
        NoDataFound,
      VuePerfectScrollbar,
      draggable
    },
    computed:{
        checkValue(){
            let returnVal = true;
            let _self = this
            if(_self.value && _self.checkProperty(_self.value,'length')>0 ){
                _.forEach(_self.value,(mItem)=>{
                    if(_.has(mItem,'isTrashDocument') && _self.checkProperty(mItem, 'isTrashDocument') ){
                        returnVal = false;
                        return returnVal
                    }else if( _self.checkProperty(mItem, 'tasks') && _self.checkProperty(mItem, 'tasks' ,'length') >0){
                        _.forEach(mItem['tasks'],(sItem)=>{
                            if(_.has(sItem,'isTrashDocument') && _self.checkProperty(sItem, 'isTrashDocument')  ){
                                returnVal = false;
                                return returnVal
                            }else if(_self.checkProperty(sItem, 'tasks') && _self.checkProperty(sItem, 'tasks' ,'length') >0){
                                _.forEach(sItem['tasks'],(item)=>{
                                    if(_.has(item,'isTrashDocument') && _self.checkProperty(item, 'isTrashDocument')  ){
                                        returnVal = false;
                                        return returnVal
                                    
                                    }else if(_self.checkProperty(item, 'tasks') && _self.checkProperty(item, 'tasks' ,'length') >0){
                                        _.forEach(item['tasks'],(dItem)=>{
                                            if(_.has(dItem,'isTrashDocument') && _self.checkProperty(dItem, 'isTrashDocument')  ){
                                                returnVal = false;
                                                return returnVal
                                                
                                            }else if(_self.checkProperty(dItem, 'tasks') && _self.checkProperty(dItem, 'tasks' ,'length') >0){
                                                _.forEach(dItem['tasks'],(dbItem)=>{
                                                    if(_.has(dbItem,'isTrashDocument') && _self.checkProperty(dbItem, 'isTrashDocument')  ){
                                                        returnVal = false;
                                                        return returnVal
                                                    }else if(_self.checkProperty(dbItem, 'tasks') && _self.checkProperty(dbItem, 'tasks' ,'length') >0){
                                                        _.forEach(dbItem['tasks'],(yItem)=>{
                                                            if(_.has(yItem,'isTrashDocument') && _self.checkProperty(yItem, 'isTrashDocument')  ){
                                                                returnVal = false;
                                                                return returnVal
                                                            }
                                                        })
                                                    }
                                                })
                                            }
                                        })
                                    }
                                })
                            }
                        })
                    }
                })
            }else{
                returnVal = true
            }
            if(returnVal){
                setTimeout(()=>{
                    this.updateLoading(false)
                },10);
            }
            return returnVal
        }
    },
    name: "nested-draggable"
  };
  </script>
  <style scoped>
  .dragArea {
    /* min-height: 15px;
    outline: 1px dashed; */
    margin-top: 2px;
    margin-bottom: 2px;
  }
  /* .nestedDrag{
      padding-left: 20px;
  } */
  </style>